import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getListCustomer: ({ commit }, { idMesin, key }) => {
        let query = {
            iddevice: idMesin,
            key: key,
            offset: 0,
            limit: 20,
            sort_by: "count_msg",
            order_by: "asc",
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getListCustomer, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListCustomer", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
	// getHistoryPesan is deprecated, use getHistoryPesanV2 instead
    getHistoryPesan: ({ commit, rootGetters, getters }, { idMesin, nomor }) => {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            iddevice: idMesin,
            nomor: nomor,
            order_by: getFilter.orderBy,
            offset: getters.pagePesan.offset,
            limit: getters.pagePesan.limit,
        };
        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                if (key === "statusKonfirmasi") {
                    query.status = getFilterItem[key];
                }
            }
            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getHistoryPesan, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    conn.setQueryString(query);
                    commit("setListPesan", data);
                    commit("setEndPesan", data.array[data.array.length - 1]);
                    commit("setNextPagePesan", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
	getHistoryPesanV2: ({ commit, rootGetters, getters }, { idMesin, nomor, useCount = true }) => {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            iddevice: idMesin,
            nomor: nomor,
            order_by: getFilter.orderBy,
            offset: getters.pagePesan.offset,
            limit: getters.pagePesan.limit,
        };
        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                if (key === "statusKonfirmasi") {
                    query.status = getFilterItem[key];
                }
            }
            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

		
        commit("setFetching", true);
        commit("setResponse", {});
		conn.get(api.getHistoryPesanV2, query).then((res) => {
			let { code, data, status, msg } = res.data;
			if (code === 200 && status) {
				conn.setQueryString(query);
				commit("setListPesan", data);
				commit("setEndPesan", data.array[data.array.length - 1]);
				commit("setNextPagePesan", data);
				commit("setResponse", resulter.successResult(msg));
			} else {
				commit("setResponse", resulter.errorResult(msg));
			}
		}).catch((e) => {
			commit("setResponse", resulter.errorResult(e));
		}).finally(() => {
			commit("setFetching", false);
			commit("setLoadMore", false);
		});
    },
    getDetailHistoryPesan: ({ commit }, { id_pesan }) => {
        commit("setFetching", true);
        conn.get(`${api.getDetailHistoryPesan}/${id_pesan}`)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setDetailPesan", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    resendMessage: ({ commit }, { id_pesan }) => {
        let posted = new FormData();
        posted.append("id", id_pesan);

        commit("setFetching", true);
        commit("setResponse", {});

        return conn.post(api.resendMessage, posted, conn.contentType.form);
    },
    resendAllMessage: ({ commit, rootGetters, getters }, { idMesin, nomor }) => {
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let payload = {
            iddevice: idMesin,
            nomor: nomor,
        };
        Object.keys(getFilterItem).forEach((key) => {
            if (key === "periode") {
                payload.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    payload.tanggal_awal = getFilterItem[key].startDate;
                    payload.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    payload.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    payload.bulan = getFilterItem[key].month;
                }
            }
        });

        let posted = new FormData();
        Object.keys(payload).forEach((key) => {
          posted.append(key, payload[key]);
        })

        commit("setFetching", true);
        commit("setResponse", {});

        return conn.post(api.resendAllMessage, posted, conn.contentType.form)
    },
	getHistorySummary: ({ commit }, { iddevice, nomor }) => {
        commit("setFetching", true);
        conn.get(`${api.countSummary}`, {
			iddevice,
			nomor,
		}).then((res) => {
			let { code, data, status, msg } = res.data;
			if (code === 200 && status) {
				commit("setHistorySummary", data);
				commit("setResponse", resulter.successResult(msg));
			} else {
				commit("setResponse", resulter.errorResult(msg));
			}
			commit("setFetching", false);
		})
		.catch((e) => {
			commit("setFetching", false);
			commit("setResponse", resulter.errorResult(e));
		});
    },
};
